import { Type } from '../types/Type';
export function getType(value) {
    if (typeof value == 'string' || value instanceof String) {
        return Type.Text;
    }
    else if (typeof value == 'number' || value instanceof Number) {
        return Type.Float64;
    }
    else if (typeof value == 'bigint') {
        return Type.Integer64;
    }
    else if (value === true || value === false) {
        return Type.Boolean;
    }
    else if (value === null) {
        return Type.None;
    }
    else if (value instanceof Uint8Array) {
        return Type.Bytes;
    }
    else if (value instanceof URL) {
        return Type.URI;
    }
    else {
        return value.type;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2luc3BlY3QvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLGVBQWUsQ0FBQTtBQUdwQyxNQUFNLFVBQVUsT0FBTyxDQUFDLEtBQW1CO0lBQ3pDLElBQUksT0FBTyxLQUFLLElBQUksUUFBUSxJQUFJLEtBQUssWUFBWSxNQUFNLEVBQUU7UUFDdkQsT0FBTyxJQUFJLENBQUMsSUFBSSxDQUFBO0tBQ2pCO1NBQU0sSUFBSSxPQUFPLEtBQUssSUFBSSxRQUFRLElBQUksS0FBSyxZQUFZLE1BQU0sRUFBRTtRQUM5RCxPQUFPLElBQUksQ0FBQyxPQUFPLENBQUE7S0FDcEI7U0FBTSxJQUFJLE9BQU8sS0FBSyxJQUFJLFFBQVEsRUFBRTtRQUNuQyxPQUFPLElBQUksQ0FBQyxTQUFTLENBQUE7S0FDdEI7U0FBTSxJQUFJLEtBQUssS0FBSyxJQUFJLElBQUksS0FBSyxLQUFLLEtBQUssRUFBRTtRQUM1QyxPQUFPLElBQUksQ0FBQyxPQUFPLENBQUE7S0FDcEI7U0FBTSxJQUFJLEtBQUssS0FBSyxJQUFJLEVBQUU7UUFDekIsT0FBTyxJQUFJLENBQUMsSUFBSSxDQUFBO0tBQ2pCO1NBQU0sSUFBSSxLQUFLLFlBQVksVUFBVSxFQUFFO1FBQ3RDLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQTtLQUNsQjtTQUFNLElBQUksS0FBSyxZQUFZLEdBQUcsRUFBRTtRQUMvQixPQUFPLElBQUksQ0FBQyxHQUFHLENBQUE7S0FDaEI7U0FBTTtRQUNMLE9BQU8sS0FBSyxDQUFDLElBQUksQ0FBQTtLQUNsQjtBQUNILENBQUMifQ==